import { render, staticRenderFns } from "./GenericSubGroup.vue?vue&type=template&id=0b4e24a7&"
import script from "./GenericSubGroup.vue?vue&type=script&lang=js&"
export * from "./GenericSubGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports